import { render, staticRenderFns } from "./pgCartList.vue?vue&type=template&id=5baf60b7&scoped=true&"
import script from "./pgCartList.vue?vue&type=script&lang=js&"
export * from "./pgCartList.vue?vue&type=script&lang=js&"
import style0 from "./pgCartList.vue?vue&type=style&index=0&id=5baf60b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baf60b7",
  null
  
)

export default component.exports